export default __webpack_public_path__ + "5c571dc201b1d6bb62566dd24b7667d0.webp";